import React, { useEffect, useState } from 'react';
import { redirectToOld, isBtoCFlow, goToMintPackDetails } from '__utils/common-utils';
import { useMediaQuery } from 'react-responsive';
import styled from 'styled-components';
import { CommonStyledComponentProps } from '__utils/type';
import { get, getDefaultHeaders } from '__utils/ajax-wrapper';
import { ENDPOINTS } from 'constants/endpoints';
import { AjaxError, AjaxResponse } from 'rxjs/ajax'
import './index.css';
import { useSelector } from 'react-redux';
import { propsToJS } from '__utils/immutable-to-js';
import RenderViewSelector from 'views/render-view/renderView.selector';
import { useDeepCompare } from 'hooks/use-deep-memo';
import { useHistory } from "react-router-dom";


const GlobalFooterContainer = styled.div<CommonStyledComponentProps>`
    .km-copyRight {
        position: relative;
        padding-left: 30px;    
        padding-top: ${(props: any) => props.isMobile ? '24px' : ''};

    }
    .km-footer .km-link {
        width: ${(props: any) => props.isMobile ? '128px' : '200px'};
        margin-right: 16px;
    }
    .km-footer .km-copyRight:before {
        content: '';
        display: block;
        width: 1px;
        position: absolute;
        background-color: white;
        height: 160px;
        top: 1px;
        left: 0;
    }
    .km-footer .km-copy-mobile:before {
        content: '';
        display: block;
        width: 163px;
        position: absolute;
        background-color: white;
        height: 1px;
        top: 1px;
    }
`
const GlobalFooter: React.FC = () => {
    const isMobile = useMediaQuery({ maxWidth: 767 });
    const { recommedndedMintpacks } = propsToJS(useSelector(RenderViewSelector));
    const history = useHistory();

    return (
        <GlobalFooterContainer isMobile={isMobile}>
            <div className="km-footer">
                <div className={isMobile ? "" : "mint-container"}>
                    <div>
                        <div className="km-link-container">
                            <div className="km-link">
                                <h4>Quick Links</h4>
                                <ul>
                                    <li><a href="/best-performing-funds">Best Performing Funds</a></li>
                                    <li><a href="/mutual-fund-results/Equity/ELSS%20(Tax%20savings)?mutualFundCategory=Equity&subCategory=ELSS%20(Tax%20savings)">Tax Saving Funds</a></li>
                                    <li><a href="/mutual-fund-results/Equity?mutualFundCategory=Equity">Equity Funds</a></li>
                                    <li><a href="/mutual-fund-results/Fixed%20Income?mutualFundCategory=Fixed%20Income">Debt Funds</a></li>
                                    <li><a href="/mutual-fund-results/Allocation/Less%20than%201%20Year?mutualFundCategory=Allocation">Balanced Funds</a></li>
                                    <li><a href="/mutual-fund-results/Money%20Market/Liquid?mutualFundCategory=Money%20Market&subCategory=Liquid">Liquid Funds</a></li>
                                </ul>
                            </div>
                            {/* <div className="km-link">
                                <h4>Mintpacks</h4>
                                <ul>
                                    {recommedndedMintpacks && recommedndedMintpacks.map((pack: any, index: number) =>
                                        <li key={index}>
                                            <a onClick={() => goToMintPackDetails(pack)}>{pack?.goalName}</a>
                                        </li>
                                    )}
                                </ul>
                            </div> */}
                            <div className="km-link">
                                <h4>Company</h4>
                                <ul>
                                    <li><a href="/contact-us">Contact Us</a></li>
                                    <li><a href='terms-conditions'>Terms & Conditions</a></li>
                                    <li><a href='privacy-policy'>Privacy Policy</a></li>
                                    <li><a href="https://docs.google.com/gview?embedded=true&url=https://docs.turtlemintmoney.com/docs/TMF-Comission-Disclosure.pdf">Disclosures</a></li>
                                    <li><a href="https://www.sebi.gov.in/">SEBI</a></li>
                                    <li><a href="https://www.amfiindia.com/">AMFI</a></li>
                                    <li><a href="https://www.amfiindia.com/downloads/revised-code-conduct-of-inter-mf">AMFI - Code of Conduct</a></li>
                                    { isBtoCFlow() && <li><a href="https://docs.turtlemintmoney.com/docs/TMF-Form-MGT-7.pdf" target="_blank">Annual Returns</a></li>}
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className={!isMobile ? "km-copyRight" : "km-copy-mobile"}>
                        <p>Copyright &copy; 2025 Turtlemint Mutual Funds Distributors Private Limited <br />
                            All Rights Reserved
                        </p>
                        <p>AMFI Registered Distributor | ARN - 159953 | Date of Initial Registration - 13th Feb 2019 | ARN validity upto - 13 Feb 2028</p>
                        <p>Mutual Fund investments are subject to market risks, read all scheme related documents carefully.</p>
                    </div>
                </div>
            </div>
        </GlobalFooterContainer>
    )
}

export default GlobalFooter;